import React from 'react';
import { ProgressBar } from 'react-bootstrap';

import useGlobal from '../../../../../store';
import { TheError } from '../../../../../shared/responses/TheResult';

const mapState = (store) => {
  return store.modulo.cancelaciones.upload;
};

const mapActions = (actions) => {
  return { ...actions.modulo.cancelaciones.upload };
};

const CancelacionesUploadForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data, progress, busy, error } = state;

  const select = (event) => {
    actions.onChange({
      file: event.target.files[0],
    });
  };

  // const handleOnChange = (values) => {
  //   actions.onChange(values);
  // }

  return (
    <>
      {!!error && <TheError error={error} />}

      <label>
        <input
          type="file"
          accept=".csv, .txt, .xls, .xlsx"
          onChange={select}
        />
      </label>

      <div className="p-3">
        <label>Instrucciones.</label>
        <ul className="list-unstyled">
          {/* <li>1. Descarga el <a target="_blank" href="/resources/template_ingreso_egreso.xlsx">template</a></li>
          <li>2. Sigue la <a target="_blank" href="/resources/guia_de_llenado_excel.pdf">guía de llenado</a></li> */}
          <li>1. Descarga el template</li>
          <li>2. Sigue la guía de llenado</li>
          <li>3. Sube el archivo</li>
        </ul>
      </div>

      {(busy || progress > 0) && !!data.file && (
        <ProgressBar
          striped
          variant="info"
          label={`${progress}%`}
          now={progress}
        />
      )}
    </>
  );
};

export default CancelacionesUploadForm;
